import github from "../assets/images/github.svg"
import linkedin from "../assets/images/linkedin.svg"

export default [
  {
    id: 3,
    title: "Github",
    icon: github,
    linkTo: true,
    path: "https://github.com/prateek951",
  },
  {
    id: 4,
    title: "LinkedIn",
    icon: linkedin,
    linkTo: true,
    path: "https://www.linkedin.com/in/prateek-madaan-08a7919a/",
  },
]
